import { Link } from "react-router-dom";

const columns = [
  {
    title: "Marketplace",
    links: [
      { label: "Browse all", href: "/marketplace" },
      { label: "Rare finds", href: "/marketplace?rail=rare-finds" },
      { label: "New arrivals", href: "/marketplace?rail=new" },
      { label: "Sell your stuff", href: "/sell" },
    ],
  },
  {
    title: "Account",
    links: [
      { label: "Sign in", href: "/login" },
      { label: "Create account", href: "/signup" },
      { label: "Favourites", href: "/favourites" },
      { label: "Cart", href: "/cart" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "/" },
      { label: "Seller guidelines", href: "/sell" },
      { label: "Support", href: "/" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-cyan-100/15 bg-[#05122f] mt-24 overflow-hidden">
      <div className="nm-starfield absolute inset-0 opacity-20" />
      <div className="nm-gold-rule absolute inset-x-0 top-0" />
      <div className="nm-container py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2 md:col-span-2">
          <div className="relative flex items-center gap-3">
            <img src="/images/logo-mark-v3.webp" alt="" className="h-11 w-11 rounded-xl bg-[#071a42] object-contain" />
            <span className="font-display text-lg font-black text-white">
              NERD <span className="text-[var(--nm-gold)]">MULTIVERSE</span>
            </span>
          </div>
          <p className="mt-4 text-sm text-[var(--nm-ink-muted)] max-w-xs">
            One marketplace. Infinite fandoms. An independent UK marketplace
            for second-hand nerd, geek and collector goods.
          </p>
        </div>
        {columns.map((col) => (
          <div key={col.title}>
            <p className="text-sm font-medium text-white mb-4">{col.title}</p>
            <ul className="space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.href}
                    className="text-sm text-[var(--nm-ink-muted)] hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="nm-container py-6 flex flex-col md:flex-row gap-4 items-center justify-between text-xs text-[var(--nm-ink-muted)]">
          <p>© {new Date().getFullYear()} Nerd Multiverse. Not affiliated with any franchise represented on the marketplace.</p>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-white transition-colors">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
